import { isNumber } from 'lodash';
import { safeHTML } from '../../../../../utils/safeHTML';

export default function Count({ count }) {
  return isNumber(count) && <div className={'button__count custom-button__count'}>{safeHTML(count)}</div>;
}
